var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/system';
import { SideImageLayout } from 'hx-ui';
import { cn } from 'hx-util';
import { useNavigate } from 'react-router-dom';
import { CustomBestBuyLogo } from './custom-best-buy-logo';
import { Footer } from './footer.component';
import { AnimatedButton } from './animated-button.component';
import { useState } from 'react';
export function InstructionsStep() {
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.up('md'));
    return (_jsx(SideImageLayout, { header: !isMobile ? _jsx(Instructions, { className: 'pb-0' }) : undefined, leftPanel: _jsx(Instructions, {}), leftPanelWidth: '40%', content: _jsx(MainContent, {}), footer: _jsx(Footer, {}) }));
}
function Instructions(_a) {
    var className = _a.className;
    return (_jsxs("div", __assign({ className: cn('flex flex-col justify-center items-center md:gap-16 gap-6 h-full md:bg-primary p-6 w-full', className) }, { children: [_jsx(CustomBestBuyLogo, { className: "md:text-white", imageHeight: 80, imageWidth: 128 }), _jsx(Typography, __assign({ className: "md:text-white text-lg font-bold md:text-2xl" }, { children: "Hearing assessment instructions" })), _jsxs("div", __assign({ className: 'flex flex-col gap-4 md:gap-6' }, { children: [_jsxs(Typography, __assign({ className: 'md:text-xl md:text-white' }, { children: ["We will play ", _jsx("strong", { children: "3 numbers" }), " with background noise."] })), _jsxs(Typography, __assign({ className: 'md:text-xl md:text-white' }, { children: ["Enter the numbers you hear in the order you hear them and press", ' ', _jsx("strong", { children: "OK." })] })), _jsxs(Typography, __assign({ className: 'md:text-xl md:text-white' }, { children: ["If you can't hear the numbers clearly, enter your", ' ', _jsx("strong", { children: "best guess." })] }))] }))] })));
}
function MainContent() {
    var _a = useState('START'), buttonText = _a[0], setButtonText = _a[1];
    var navigate = useNavigate();
    function onClick() {
        if (buttonText !== 'START')
            return;
        var currentCount = 5;
        setButtonText("".concat(currentCount));
        var timerId = setInterval(function () {
            currentCount--;
            if (currentCount > 0) {
                setButtonText("".concat(currentCount));
            }
            else {
                clearInterval(timerId);
                navigate('/din-test');
            }
        }, 1000);
    }
    return (_jsx("div", __assign({ className: 'flex justify-center items-center w-full h-full' }, { children: _jsx(AnimatedButton, __assign({ onClick: onClick, duration: 5 }, { children: _jsx("span", __assign({ className: cn('text-xl text-white font-bold', {
                    'text-4xl': buttonText !== 'START',
                }) }, { children: buttonText })) })) })));
}
